import React, { Component } from 'react';
import { ErrorMessage, Field } from 'formik';
import { iconForField } from '../../../../common/custom/icon-library';

class BooleanField extends Component {
  render() {
    const { field, isConstructorForm } = this.props;
    return (
      <>
        {/* <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title={field.fieldTitle['en']}>
                <span className="input-group-text">
                  <i className={`wb ${iconForField(field.type + '-toggle')}`}></i>
                  <span className="required">
                    {field.required && !isConstructorForm ? ' *' : ''}
                  </span>
                </span>
              </div> */}

        <div className="form-check">
          <label className="form-check-label">
            <Field
              type="checkbox"
              name={field.fieldName}
              className="form-check-input"
              title={field.fieldTitle['en']}
            />
            {field.fieldTitle['en']}
            {field.required && !isConstructorForm ? ' *' : ''}
            <span className="form-check-sign">
              <span className="check"></span>
            </span>
          </label>
          <p className="errors">
            <ErrorMessage name={field.fieldName} />
          </p>
        </div>
        {/* </div>
          </div>
        </div> */}
      </>
    );
  }
}

export default BooleanField;
